export default function TitanDataWhiteIco({width = 129, height = 40}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 151 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.9316 4.82227C28.4201 9.4983 24.8108 21.4797 14.4658 32C4.12086 21.4797 0.511552 9.4983 0 4.82227L14.4658 0L28.9316 4.82227Z"
        fill="#7F56D9"
      />
      <path
        d="M24.1087 7.45521L14.4648 4.38672V26.3045L18.8484 20.1675V11.4004H22.7936L24.1087 7.45521Z"
        fill="#D4C0FF"
      />
      <path
        d="M4.82101 7.45521L14.4648 4.38672V26.3045L10.0813 20.1675V11.4004H6.13608L4.82101 7.45521Z"
        fill="white"
      />
      <path
        d="M39.916 9.12177V7.45952H51.8253V9.12177H46.8175V22.5039H44.9238V9.12177H39.916ZM53.7474 22.5039V7.45952H55.6411V22.5039H53.7474ZM57.5462 9.12177V7.45952H69.4554V9.12177H64.4476V22.5039H62.5539V9.12177H57.5462ZM68.2457 22.5039L73.7795 7.45952H75.9047L81.4595 22.5039H79.3975L77.7984 17.9169H71.8017L70.1815 22.5039H68.2457ZM74.1372 11.3311L72.3487 16.3809H77.2724L75.547 11.3311L74.8737 9.20593H74.8316C74.5651 10.0476 74.3336 10.756 74.1372 11.3311ZM83.0889 22.5039V7.45952H85.0878L91.9472 17.9169L93.0413 19.8527H93.0834V7.45952H94.8509V22.5039H92.9151L86.0136 12.0254L84.8984 10.1528H84.8564V22.5039H83.0889ZM100.775 22.5039V7.45952H106.645C108.637 7.45952 110.236 8.18193 111.443 9.62675C112.649 11.0575 113.252 12.8951 113.252 15.1395C113.252 17.7346 112.453 19.7054 110.853 21.0521C109.689 22.02 108.202 22.5039 106.393 22.5039H100.775ZM103.826 19.8738H106.182C107.571 19.8738 108.581 19.474 109.212 18.6744C109.843 17.8608 110.159 16.6825 110.159 15.1395C110.159 13.5965 109.822 12.3691 109.149 11.4573C108.49 10.5315 107.529 10.0686 106.266 10.0686H103.826V19.8738ZM112.975 22.5039L118.214 7.45952H121.371L126.673 22.5039H123.496L122.486 19.3057H117.057L116.068 22.5039H112.975ZM119.119 12.6356L117.773 16.9701H121.749L120.403 12.6356L119.792 10.3211H119.75C119.498 11.3311 119.287 12.1026 119.119 12.6356ZM125.27 10.0265V7.45952H137.369V10.0265H132.845V22.5039H129.794V10.0265H125.27ZM135.927 22.5039L141.166 7.45952H144.323L149.625 22.5039H146.448L145.438 19.3057H140.009L139.02 22.5039H135.927ZM142.071 12.6356L140.725 16.9701H144.701L143.355 12.6356L142.745 10.3211H142.702C142.45 11.3311 142.24 12.1026 142.071 12.6356Z"
        fill="white"
      />
    </svg>
  );
}
